import orgamax from 'ampersand-app'
import lang from '@/lang'
import config from '@/config'
import { isIE } from './isBrowser'
import isElectron from './isElectron'
import { toast } from '@/modules/base/components/toast/toastConfig'

export const printAndCombineByPdfUrl = (url, documentArray, cb) => {
  toast.showToast({
    message: lang.generics.printingWait,
  })

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${orgamax.user.token}`,
    },
    body: JSON.stringify({ documents: documentArray }),
  }).then(response => response.blob())
    .then((data) => {
      const documentUrl = `${config.imageResourceHost}${data}`

      if (!isElectron()) {
        const oldPrintFrame = document.getElementById('printFrame')

        if (oldPrintFrame) {
          oldPrintFrame.parentNode.removeChild(oldPrintFrame)
        }

        const newBlob = new Blob([data], { type: 'application/pdf' })
        const objectURL = window.URL.createObjectURL(newBlob)

        const printFrame = document.createElement('iframe')
        printFrame.id = 'printFrame'
        printFrame.name = 'printFrame'
        printFrame.style.display = 'none'
        printFrame.src = objectURL

        if (!isIE()) {
          printFrame.onload = () => {
            printFrame.contentWindow.focus()
            printFrame.contentWindow.print()
            cb && cb()
          }
        } else {
          printFrame.onload = () => {
            setTimeout(() => {
              printFrame.contentWindow.focus()
              printFrame.contentWindow.print()
              cb && cb()
            }, 1000)
          }
        }
        document.body.append(printFrame)
      } else {
        window.electron.printByUrl(documentUrl)
      }
    })
    .catch((error) => {
      console.error(error)
      toast.showToast({
        type: 'error',
        message: lang.generics.printingError,
      })
    })
}
